var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "client_location",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10991",
    "data-name": "Path 10991",
    d: "M93.19,51.226a50.94,50.94,0,0,0,13.271,1.563,50.935,50.935,0,0,0,13.271-1.563c4.366-1.233,6.579-3.018,6.579-5.306s-2.214-4.072-6.579-5.306a41.389,41.389,0,0,0-6.908-1.247c5.011-8.553,9.977-18.238,9.977-23.027a16.341,16.341,0,0,0-32.681,0c0,4.789,4.966,14.474,9.977,23.027a41.374,41.374,0,0,0-6.907,1.248c-4.366,1.233-6.579,3.018-6.579,5.306S88.824,49.993,93.19,51.226ZM106.461,3.516a12.839,12.839,0,0,1,12.825,12.825c0,3.632-4.494,13.154-12.022,25.471a.94.94,0,0,1-1.606,0C98.13,29.495,93.636,19.973,93.636,16.341A12.84,12.84,0,0,1,106.461,3.516ZM94.784,43.827a42.731,42.731,0,0,1,7.314-1.1q.282.465.561.921a4.456,4.456,0,0,0,7.605,0q.279-.456.561-.921a42.732,42.732,0,0,1,7.314,1.1c3.213.818,4.387,1.74,4.628,2.094-.241.354-1.415,1.275-4.628,2.094a49.329,49.329,0,0,1-11.677,1.26,49.327,49.327,0,0,1-11.677-1.26c-3.213-.818-4.386-1.74-4.628-2.094C90.4,45.566,91.571,44.645,94.784,43.827Z",
    transform: "translate(-76.461)",
    fill: "#d0d0d0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10992",
    "data-name": "Path 10992",
    d: "M54.882,357.333a1.758,1.758,0,0,0-1.693,3.081c2.094,1.15,3.295,2.426,3.295,3.5,0,1.313-1.86,3.347-7.08,5.12A62.768,62.768,0,0,1,30,371.75a62.768,62.768,0,0,1-19.4-2.717c-5.22-1.773-7.08-3.808-7.08-5.12,0-1.073,1.2-2.348,3.295-3.5a1.758,1.758,0,0,0-1.693-3.081C2.783,358.615,0,360.8,0,363.913c0,2.388,1.642,5.792,9.464,8.449A66.317,66.317,0,0,0,30,375.266a66.317,66.317,0,0,0,20.536-2.9C58.358,369.7,60,366.3,60,363.913,60,360.8,57.217,358.615,54.882,357.333Z",
    transform: "translate(0 -315.266)",
    fill: "#d0d0d0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10993",
    "data-name": "Path 10993",
    d: "M213.089,80.388a6.568,6.568,0,1,0-6.568,6.568A6.575,6.575,0,0,0,213.089,80.388Zm-9.62,0a3.052,3.052,0,1,1,3.052,3.052A3.056,3.056,0,0,1,203.469,80.388Z",
    transform: "translate(-176.521 -65.169)",
    fill: "#d0d0d0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientLocation);
export default __webpack_public_path__ + "static/media/client_location.0f730281f951f154bd2370970aee8395.svg";
export { ForwardRef as ReactComponent };